import React, { Fragment, useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row ,Table, Button,Popover, PopoverBody, PopoverHeader } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams, Link } from "react-router-dom";

import Breadcrumb from "../../../../layout/breadcrumb";
import orderReducer from "../../store";
import PreLoader from "../../../../share-components/ui/preLoader";
import withReducer from "../../../../store/withReducer";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import LogActivity from "../../../log";


import {
    resendTrackingEmail,
    showAlterationRequest,
    syncReturnTracking,
    viewPendingReturnRequestList
} from "../../store/orderSlice";

import "./style.scss";
import ReturnProcessTimeline from "../../pending-return/view/content/ReturnProcessTimeline";

const ViewAlterationRequest = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    let history = useHistory();
    const orderState = useSelector(({ order }) => order.order);
    const [loading, isSetLoading] = useState(true);
    const authData = useSelector(({ authReducer }) => authReducer);
    const userState =  authData.data;
    const [tableLoading, isSetTableLoading] = useState(false);
    const [syncTrackingButtonDisabled, setSyncTrackingButtonDisabled] = useState(false);
    const [resendButtonDisabled, setResendButtonDisabled] = useState(false);

    const dataMenu = [
        {
            type: 1,
            text: 'Alteration Requests',
            link: '/order/alteration-requests'
        },
        {
            type: 0,
            text: "View"
        }
    ];

    useEffect(() => {
        const requestParmas = {
            params: {
                seller: authData.defaultSeller?.value
            },
            id: id
        }
        isSetTableLoading(true);
        dispatch(showAlterationRequest(requestParmas)).then(res => {
            if (!res.error) {
                isSetLoading(false);
            }
            isSetTableLoading(false);
        });
    }, [dispatch, authData.defaultSeller]);


    let tableColumns = [
        {
            name: 'Product',
            selector: row => row.product_name,
            cell: (row) => (
                <div className="item-row">
                    <div className="item-image-col">
                        <img className="img-fluid" src={row.image} width="40" alt="" />
                    </div>
                    <div className="item-content-col">
                        <p className="text-primary font-weight-bold">{row.product_name}</p>
                        <p>{row.colour}/{row.size}</p>
                        <p>{row.sku}</p>
                        <p>{row.brand_name}</p>
                        <p><b>Note:</b> {row.note}</p>
                    </div>
                </div>
            ),
            width: "40%",
            sortable: false,
            center: false,
        },
        {
            name: 'SKU',
            selector: row => row.sku,
            sortable: false,
            center: true,
        },
        {
            name: 'Length',
            selector: row => row.length,
            sortable: false,
            center: true,
        },
        {
            name: 'Ordered Qty',
            selector: row => row.ordered_quantity,
            width: "10%",
            sortable: false,
            center: true,
        },
        {
            name: 'Requested Qty',
            selector: row => row.request_quantity,
            width: "10%",
            sortable: false,
            center: true,
        },
        {
            name: 'Status',
            selector: row => row.status_id,
            cell: (row) => (
                <div>
                    <span className={`badge px-3 ${{
                        1: 'badge-primary',
                        2: 'badge-warning',
                        3: 'badge-success',
                    }[row.status_id] || 'badge-danger'}`}>
                        {row.status}
                    </span>
                </div>
            ),
            width: "200px",
            sortable: false,
            center: true,
        },

    ];

    const onEdit = (row) => {
        history.push(`/order/alteration-requests/${row.id}/edit`);
    };

    // Tracking   
    let trackingTableColumns = [
        {
            name: 'ID',
            selector: row => row.id,
            width: "100px",
            sortable: false,
            center: false,
        },
        {
            name: 'Tracking Name',
            selector: row => row.tracking_name,
            sortable: false,
            center: false,
        },
        {
            name: 'Tracking ID',
            selector: row => <div className="py-2">
                <a target="blank" style={{ textWrap: 'balance' }} href={row.tracking_url}>{row.tracking_id}</a>
            </div>,
            sortable: false,
            center: false,
        },
        {
            name: 'Tracking URL',
            selector: row => <div className="py-2">
                <a target="blank" style={{ textWrap: 'balance' }} href={row.tracking_url}>{row.tracking_url}</a>
            </div>,
            sortable: false,
            center: false,
        },
        {
            name: 'Created At',
            selector: row => row.created_at,
            sortable: false,
            center: false,
        },
        {
            name: 'Updated At',
            selector: row => row.updated_at,
            sortable: false,
            center: false,
        },
    ];

    // data provides access to your row data
    const expandedChildItems = ({ data }) => {
        const childTableColumns = [
            {
                name: 'Product',
                selector: row => row.product_name,
                cell: (row) => (
                    <div className="item-row">
                        <div className="item-image-col">
                            <img className="img-fluid" src={row.image} width="40" alt="" />
                        </div>
                        <div className="item-content-col">
                            <p className="text-primary font-weight-bold">{row.product_name}</p>
                            <p>{row.colour}/{row.size}</p>
                            <p>{row.sku}</p>
                            <p>{row.brand_name}</p>
                            <p><b>Note:</b> {row.note}</p>
                        </div>
                    </div>
                ),
                width: "40%",
                sortable: false,
                center: false,
            },
            {
                name: 'SKU',
                selector: row => row.sku,
                sortable: false,
                center: true,
            },
            {
                name: 'Length',
                selector: row => row.length,
                sortable: false,
                center: true,
            },
            {
                name: 'Ordered Qty',
                selector: row => row.ordered_quantity,
                width: "10%",
                sortable: false,
                center: true,
            },
            {
                name: 'Requested Qty',
                selector: row => row.request_quantity,
                width: "10%",
                sortable: false,
                center: true,
            },
            {
                name: 'Status',
                selector: row => row.status_id,
                cell: (row) => (
                    <div>
                        <span className={`badge px-3 ${{
                            1: 'badge-secondary',
                            2: 'badge-primary',
                            3: 'badge-success',
                        }[row.status_id] || 'badge-danger'}`}>
                            {row.status}
                        </span>
                    </div>
                ),
                width: "200px",
                sortable: false,
                center: true,
            },
        ];

        const childData = data.items;

        return (
            <div className="px-5 pt-3 pb-5 border-bottom">
                <CommonDataTable
                    className="refunded-histories-child-table"
                    headerColumns={childTableColumns}
                    data={childData}
                    noAction
                    pagination={false}
                />
            </div>
        );
    };


    const fetchView = () => {        
        const requestParmas = {
            params: {
                seller: authData.defaultSeller?.value
            },
            id: id
        }
        dispatch(showAlterationRequest(requestParmas)).then(res => {
            if (!res.error) {
                isSetLoading(false);
                setSyncTrackingButtonDisabled(false);
            }
        });
    }

    const resendTrackingEmailClick = (tracking_id) => {
        setResendButtonDisabled(true);
        const payload = {
            tracking_id: tracking_id
        }
        dispatch(resendTrackingEmail({ ...payload })).then(res => {
            setResendButtonDisabled(false);
        });
    }

    const syncTrackingClick = (tracking_id) => {
        setSyncTrackingButtonDisabled(true);
        const payload = {
            tracking_id: tracking_id
        }
        dispatch(syncReturnTracking({ ...payload })).then(res => {
            if (!res.error) {
                fetchView();
            }
            setSyncTrackingButtonDisabled(false);
        });
    }

    const PopoverSyncTracking = (props) => {
        const {list} = props;
        const [popover, setPopover] = useState(false)
        const Toggle = () => setPopover(!popover);
        return (
            <>
                <Button color="primary" size="xs" type="button" className="" id={"SyncTrackingPopover-" + list.tracking.id} 
                    onClick={() => {
                        syncTrackingClick(list.tracking.id)
                    }} 
                    disabled={syncTrackingButtonDisabled || list.can_sync_tracking_status == 2}>
                        {syncTrackingButtonDisabled && <i className="fa fa-spinner fa-spin" />} Fetch Tracking Status
                </Button>
                {(list.can_sync_tracking_status == 2) && (
                    <Popover
                        placement="top"
                        isOpen={popover}
                        target={"SyncTrackingPopover-" + list.tracking.id}
                        toggle={Toggle}
                        trigger="hover"
                    >
                        <PopoverBody>
                            You have reached the usage limit for today. Please try again tomorrow.
                        </PopoverBody>
                    </Popover>
                )}
            </>
        );
    };

    const TrackingDirection = ({ list }) => {
        if (!list || !list.tracking) return null;

        const directions = {
            alteration_request: { from: "Customer", to: "Store", fromColor: "#d62828", toColor: "#003049" },
            alteration_processed: { from: "Store", to: "Customer", fromColor: "#003049", toColor: "#d62828" },
        };

        const trackingType = list.tracking.type;
        const direction = directions[trackingType];

        if (!direction) return null;

        return (
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
            <span style={{ color: direction.fromColor }}>{direction.from}</span>
            <span style={{ margin: "0 8px", color: "#000", fontWeight: 900 }}>→</span>
            <span style={{ color: direction.toColor }}>{direction.to}</span>
            <span style={{fontWeight:500,marginLeft : 10 }}>{`| ${list.tracking_date}`}</span>
            </div>
        );
    };


    return (
        <Fragment>
            {loading ? <>
                <PreLoader></PreLoader>
            </> : <>
                <Breadcrumb title="View Alteration Request" data={dataMenu} />
                <Container fluid={true} className="alteration-view">

                    <div style={{position: 'fixed', top: '50%', zIndex: 10,right:0}}>
                        <LogActivity log="Alteration Request" id={id}></LogActivity>
                    </div>

                    <Row>
                        <Col sm="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="">
                                            <h5 className="mb-2">Details of Alteration Request</h5>
                                        </Col>
                                        <Col md="1">
                                            {orderState.alterationRequestData.data?.status != 'Completed' && (
                                                <a
                                                    onClick={() => onEdit(orderState.alterationRequestData.data)}
                                                    className={`btn btn-primary btn-sm px-2 py-1 float-right`}
                                                >
                                                    <i className="fa fa-reply"></i> Open Edit
                                                </a>
                                            )}
                                        </Col>
                                    </Row>


                                    <Row>
                                        <Col>
                                            <p><b>Requested Date:</b> {orderState.alterationRequestData.data?.requested_date}</p>
                                            <p>
                                                <b>Status:</b>
                                                <span className={`badge px-2 ml-2 ${{
                                                    'Pending': 'badge-primary',
                                                    'Completed': 'badge-success',
                                                    'Processing': 'badge-warning'
                                                }[orderState.alterationRequestData.data?.status]}`}>
                                                    {orderState.alterationRequestData.data?.status}
                                                </span>
                                            </p>
                                            <p>
                                                <b>Order No:</b>
                                                <Link
                                                    className="text-primary ml-2"
                                                    style={{ cursor: "pointer" }}
                                                    target="_blank"
                                                    to={`${process.env.PUBLIC_URL}/order/${orderState.alterationRequestData.data?.order_id}/view`}
                                                >
                                                    {orderState.alterationRequestData.data?.order_name}
                                                </Link>
                                            </p>
                                            <p><b>Customer:</b> {orderState.alterationRequestData.data?.customer_name}</p>
                                        </Col>
                                    </Row>

                                    <h5 className="mb-2 mt-5">List of Requested Items</h5>

                                    <div className="table-responsive">
                                        <CommonDataTable
                                            headerColumns={tableColumns}
                                            progressPending={tableLoading}
                                            data={orderState.alterationRequestData.data?.items}
                                            noAction
                                            pagination={false}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                   {orderState.alterationRequestData.lists && 
                        orderState.alterationRequestData.lists.map((list, index) => (
                            <Card className="ribbon-wrapper" key={index}>
                                <CardBody>
                                    <div className="ribbon ribbon-clip h6 ribbon-info">{list.brand_name}</div>
                                    
                                    <TrackingDirection list={list}/>

                                    {list.tracking && list.tracking.tracking_number ? (
                                        <div className="table-responsive">
                                            <Table style={{width:'100%', border: "none"}}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{width:'50%', paddingLeft: 0}}>
                                                            <p><strong>Tracking Details:</strong></p>
                                                            <p><strong>Carrier:</strong> {list.tracking.tracking_name}</p>
                                                            <p><strong>Tracking Number:</strong> {list.tracking.tracking_number}</p>
                                                            <p>
                                                                <strong>Tracking URL:</strong> 
                                                                <a style={{textDecoration: 'underline', color: 'blue'}} target="_blank" href={list.tracking.tracking_url}>
                                                                    {list.tracking.tracking_url}
                                                                </a>
                                                            </p>
                                                            {list.can_sync_tracking_status !== 0 && <p><PopoverSyncTracking list={list} /></p>}
                                                        </td>
                                                        <td>
                                                            {/* Other buttons / QR code / labels */}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">Tracking details not found.</div>
                                    )}

                                    {list.tracking_summary && (
                                        <div className="mt-2 mb-5">
                                            <h6>Tracking Status:</h6>
                                            <ReturnProcessTimeline trackingSummary={list.tracking_summary} />
                                        </div>
                                    )}

                                    <div className="table-responsive mt-3">
                                        <Table style={{width:'100%'}}>
                                            <thead>
                                                <tr className="table-primary">
                                                    <th style={{ whiteSpace: 'nowrap',width:'30%' }}>Product</th>
                                                    <th style={{ whiteSpace: 'nowrap',width:'10%' }}>Qty</th>
                                                    <th style={{ whiteSpace: 'nowrap',width:'15%' }}>Customer Reason</th>
                                                    <th style={{ whiteSpace: 'nowrap',width:'10%' }}>Status</th>
                                                    {userState.user.role.name !== "Seller" && <th style={{ whiteSpace: 'nowrap',width:'10%' }}>Created at</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.items.map((item) => (
                                                    <tr key={item.id}>
                                                        <th>
                                                            <div className="row">
                                                                <div className="col-md-2">
                                                                    <img className="img-fluid" src={item.image} width="40" alt="" />
                                                                </div>
                                                                <div className="col-md-9">
                                                                    <div className="row">
                                                                        <p className="font-primary">{item.productName}</p>
                                                                    </div>
                                                                    <div className="row">
                                                                        <p>{item.itemSku}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <td>{item.returnRequestQuantity}</td>
                                                        <td><div className="mt-3">{item.reasonRequest}</div></td>
                                                        <td><div className="mt-3">{item.status}</div></td>
                                                        {userState.user.role.name !== "Seller" && (
                                                            <td><div className="mt-3">{item.created_at || "-"}</div></td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                    ))}

                    
                    {orderState.alterationRequestData.data?.trackings && orderState.alterationRequestData.data?.trackings.length > 0 && (
                        <Row>
                            <Col sm="12">
                                <Card>
                                    <CardBody>
                                        <h5 className="mb-2">List of Trackings</h5>

                                        <div className="table-responsive product-table">
                                            <CommonDataTable
                                                headerColumns={trackingTableColumns}
                                                progressPending={tableLoading}
                                                data={orderState.alterationRequestData.data?.trackings}
                                                noAction
                                                pagination={false}
                                                expandableRows
                                                expandableRowsComponent={expandedChildItems}
                                            />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </Container>
            </>}
        </Fragment>
    );
}

export default withReducer([{ order: orderReducer }])(ViewAlterationRequest);